import React from 'react'
import StyledDiv from './styles'

interface IProps {
  color: string
  id?: string
  text?: string
  textColor?: string
  logo?: string
}

const LOGO_SIZE = 21

export const StopMarker: React.FC<IProps> = ({ color, id, text, textColor, logo }) => {

  return (
    <StyledDiv id={id}>
      { 
        text && 
        (
          <>
            <div className='label' style={{ backgroundColor: color, color: textColor }}>
              { text }
            </div>
            <div className='marker-line' style={{ backgroundColor: color }}></div>
          </>
        )
      }
      {
        logo
          ? <img src={ logo } width={ LOGO_SIZE } height={ LOGO_SIZE } alt='' />
          : (
            <div className='marker-dot' style={{ backgroundColor: color }}>
              <div className='marker-white'></div>
            </div>
          )
      }
    </StyledDiv>
  )
}